import   React                  , 
       { useState               , 
	     useEffect              }  from 'react';
		 
import   classNames                from 'classnames';

import   styles                    from './AdSpotSheet.module.scss';

import   Field                     from '../../widget/inputs/Field';
import   TextArea                  from '../../widget/inputs/TextArea';
import   Toggle                    from '../../widget/inputs/Toggle';
import   Trigger                   from '../../widget/actuators/Trigger';
import   WidgetFrame               from '../../widget/navigation/WidgetFrame';
import   Window                    from '../../widget/windows/window';
import   Label                     from '../../widget/dataDisplay/labels/Label';


import { AdSpot                 , 
		 initializedAdSpot      }  from '../../../dataTypes/mediaManagment/adSpot_types';

import { convertDateToString  }  from '../../../dataTypes/timeManagment/utils';

import { WWW_URLS               }  from '../../../backendServices/urls';

/*
import { updateAdSpot                ,
         createAdSpot                }  from '../../../backendServices/mediaManagment/api_video';
*/

		 
export interface AdSpotSheetProps {
  adSpot?: AdSpot;
  onClose?: () => void;
  onCreate?: (id: number) => void;
  onEdit?: (id: number) => void;
}

export const AdSpotSheet = ({ adSpot, onClose, onCreate, onEdit }: AdSpotSheetProps) => {
  const isEditMode = adSpot !== undefined;
  const initialAdSpot: AdSpot = isEditMode ? adSpot! : initializedAdSpot();

  const [ id] = useState(initialAdSpot.id);
  const [ creationDate] = useState(initialAdSpot.creationDate);
  const [ title, setTitle] = useState(initialAdSpot.title);
  const [ description, setDescription] = useState(initialAdSpot.description);
  const [ , setDuration] = useState(initialAdSpot.duration);


  const [ active                           , setActive                           ] = useState(false);


  const [                 , setImageFileToUpload                ] = useState<File | null>(null);
  const [ imageSrc                         ] = useState(initialAdSpot.imageFile);

  const [                 , setVideoFileToUpload                ] = useState<File | null>(null);
  const [ videoSrc                         ] = useState(initialAdSpot.videoFile);


  const [ titleErrorMessage                ] = useState('');
  const [ descriptionErrorMessage          ] = useState('');
  const [ imageFileToUploadErrorMessage    ] = useState('');
  const [ videoFileToUploadErrorMessage    ] = useState('');


  const [ numberOfModifiedFields           ] = useState(0);

  const [ saved                            , setSaved                            ] = useState(false);
  const [ cancelation                      , setCancelation                      ] = useState(false);
  const [ error                            ] = useState(false);
  const [ progress                         , setProgress                         ] = useState(0);
  const [ saveButtonLock                   , setSaveButtonLock                   ] = useState(false);

  let adSpotSheetId: number = 0


  useEffect(() => {
    // This useEffect can be used to handle side effects when certain state variables change
  }, [imageSrc, saved, progress, error]);


/*
  const reinit = () => {
    setYoutubeIdForRetrieving('');
    setId(initialVideo.id);
    setTitle(initialVideo.title);
    setShortTitle(initialVideo.shortTitle);
    setComplementToTheTitle(initialVideo.complementToTheTitle);
    setDescription(initialVideo.description);
    setDuration(initialVideo.duration);
    setDistribution(initialVideo.distribution);
    setProduction(initialVideo.production);
    setCopyright(initialVideo.copyright);
    setFirstUseDate(initialVideo.firstUseDate);
    setReleaseDate(initialVideo.releaseDate);
    setRankingStr(`${initialVideo.ranking}`);
    setNumberOfViewsStr(`${initialVideo.numberOfViews}`);
    setImageFile(initialVideo.imageFile);
    setVideoFile(initialVideo.videoFile);
    setImageUrl('');
    setImageFileToUpload(null);
    setImageSrc('');
    setVideoFileToUpload(null);
    setUsedKeywords([]);
    setTitleErrorMessage('');
    setShortTitleErrorMessage('');
    setComplementToTheTitleErrorMessage('');
    setDescriptionErrorMessage('');
    setDurationErrorMessage('');
    setDistributionErrorMessage('');
    setProductionErrorMessage('');
    setCopyrightErrorMessage('');
    setFirstUseDateErrorMessage('');
    setReleaseDateErrorMessage('');
    setRankingStrErrorMessage('');
    setNumberOfViewsStrErrorMessage('');
    setImageFileToUploadErrorMessage('');
    setVideoFileToUploadErrorMessage('');
    setYoutubeIdErrorMessage('');
    setCategoriesErrorMessage('');
    setreadingRightsErrorMessage('');
    setKeywordsErrorMessage('');
    setUrlImage(`${WWW_URLS.Thumbnail}${imageFile}.webp`);
    setUrlImageBig(`${WWW_URLS.Thumbnail}${imageFile}_BIG.webp`);
    setNumberOfModifiedFields(0);
    setSaveButtonLock(false);
  };
*/


  const save = async () => {
/*	  
    const titleErrorMessageBis             = testTitle             (title);
    const descriptionErrorMessageBis       = testDescription       (description);
//  const distributionErrorMessageBis      = testDistribution      (distribution);
//  const productionErrorMessageBis        = testProduction        (production);
//  const copyrightErrorMessageBis         = testCopyright         (copyright);
//  const rankingStrErrorMessageBis        = testRankingStr        (rankingStr);
//  const numberOfViewsStrErrorMessageBis  = testNumberOfViewsStr  (numberOfViewsStr);
    const releaseDateErrorMessageBis       = testReleaseDate       (convertDateToString(releaseDate, 'dd/MM/yyyy'));
//    const firstUseDateErrorMessageBis      = testFirstUseDate      (convertDateToString(firstUseDate, 'dd/MM/yyyy'));

    const videoFileToUploadErrorMessageBis = testVideoFileToUpload (videoFileToUpload === null ? undefined : videoFileToUpload);
    const imageFileToUploadErrorMessageBis = testImageFileToUpload (imageFileToUpload === null ? undefined : imageFileToUpload);
    const imageFileToUploadErrorMessageTer = testImageUrl          (imageUrl);

    setTitleErrorMessage             (titleErrorMessageBis);
    setDescriptionErrorMessage       (descriptionErrorMessageBis);
//  setDistributionErrorMessage      (distributionErrorMessageBis);
//  setProductionErrorMessage        (productionErrorMessageBis);
//  setCopyrightErrorMessage         (copyrightErrorMessageBis);
//  setRankingStrErrorMessage        (rankingStrErrorMessageBis);
//  setNumberOfViewsStrErrorMessage  (numberOfViewsStrErrorMessageBis);
    setReleaseDateErrorMessage       (releaseDateErrorMessageBis);
//    setFirstUseDateErrorMessage      (firstUseDateErrorMessageBis);
    setVideoFileToUploadErrorMessage (videoFileToUploadErrorMessageBis);
    setImageFileToUploadErrorMessage (imageSrc === '' ? imageFileToUploadErrorMessageBis : '');

    const test = titleErrorMessageBis             === "" &&
                 descriptionErrorMessageBis       === "" &&
//               distributionErrorMessageBis      === "" &&
//               productionErrorMessageBis        === "" &&
//               copyrightErrorMessageBis         === "" &&
//               rankingStrErrorMessageBis        === "" &&
//               numberOfViewsStrErrorMessageBis  === "" &&
                 videoFileToUploadErrorMessageBis === "" &&
                 releaseDateErrorMessageBis       === "" &&
//                 firstUseDateErrorMessageBis      === "" &&
                 (imageSrc === '' && imageFileToUploadErrorMessageBis === "" || imageSrc !== '');

    if (numberOfModifiedFields > 0 && test) 
	      {
           setProgress(0);
           setSaved(false);

   

           const result = (isEditMode) ?
             await updateVideo ( id , title , shortTitle , complementToTheTitle , description , duration , distribution , production , copyright , releaseDate , firstUseDate , rankingStr , numberOfViewsStr , imageUrl , imageFileToUpload , videoFileToUpload , youtubeId , productId , categoriesIds , keywordsIds , setProgress ) :
             await createVideo (      title , shortTitle , complementToTheTitle , description , duration , distribution , production , copyright , releaseDate , firstUseDate , rankingStr , numberOfViewsStr , imageUrl , imageFileToUpload , videoFileToUpload , youtubeId , productId , categoriesIds , keywordsIds , setProgress );

           // Bloquer le traitement pendant 2 secondes
           await delay(5000);

                if (result.code === 1) 
	             {
                  videoSheetId = isEditMode ? id : result.payload;
                  setSaved(true);
                  setProgress(0);
                  setError(false);
                  setNumberOfModifiedFields(0);
				  
				  console.log ( "soldProduct=", soldProduct)
				  
				  
				  if ( soldProduct )
				        {
					     const soldProductPriceValue = parseFloat (soldProductPrice)

                         let associatedProduct_price: Price;
                         let associatedProduct_variant: ProductVariant;
                         let associatedProduct2: Product;

                         if (isEditMode && associatedProduct) 
					           {
                                const variant = associatedProduct.variants[0];
                                const price = variant.prices[0];

                                associatedProduct_price   = { 
                                                              id                : price.id,
                                                              name              : price.name,
                                                              requiredStatus    : price.requiredStatus,
                                                              comment           : price.comment,
                                                              code              : price.code,
                                                              active            : price.active,
                                                              creationDate      : price.creationDate,
	                                                          basePrice         : soldProductPriceValue / 1.2 ,
                                                              taxRate           : 20,
                                                              priceWithTax      : soldProductPriceValue  ,
                                                              discounts         : [],
                                                            };

                                associatedProduct_variant = {
                                                              id                : variant.id,
                                                              name              : variant.name,
                                                              complement        : variant.complement,
                                                              description       : variant.description,
                                                              code              : variant.code,
                                                              barcode           : variant.barcode,
                                                              active            : variant.active,
                                                              creationDate      : variant.creationDate,
                                                              stockAvailable    : variant.stockAvailable,
                                                              stockBooked       : variant.stockBooked,
                                                              stockAssigned     : variant.stockAssigned,
                                                              stockThreshold    : variant.stockThreshold,
                                                              characteristics   : variant.characteristics,
                                                              prices            : [associatedProduct_price],
                                                            };

                                associatedProduct2        = {
                                                              id                : associatedProduct.id,
                                                              name              : associatedProduct.name,
                                                              catchword         : associatedProduct.catchword,
                                                              code              : associatedProduct.code,
                                                              active            : true,
                                                              creationDate      : associatedProduct.creationDate,
                                                              requiredStatus    : associatedProduct.requiredStatus,
                                                              paymentRequired   : associatedProduct.paymentRequired,
                                                              kind              : associatedProduct.kind,
                                                              description       : associatedProduct.description,
                                                              variants          : [associatedProduct_variant],
                                                              characteristics   : associatedProduct.characteristics,
                                                              categoriesIds     : associatedProduct.categoriesIds,
                                                              associatedMediaId : associatedProduct.associatedMediaId,
                                                            };
   
                                const result2 = await updateProduct ( associatedProduct2 ) 
                               }
                          else {
                                associatedProduct_price   = {
                                                              id                : 0,
                                                              name              : title,
                                                              requiredStatus    : null,
                                                              comment           : null,
                                                              code              : 'p1',
                                                              active            : true,
                                                              creationDate      : new Date(),
                                                              basePrice         : soldProductPriceValue / 1.2,
                                                              taxRate           : 20,
                                                              priceWithTax      : soldProductPriceValue ,
                                                              discounts         : [],
                                                            };

                                associatedProduct_variant = {
                                                              id                : 0,
                                                              name              : title,
                                                              complement        : '',
                                                              description       : '',
                                                              code              : 'v1',
                                                              barcode           : '',
                                                              active            : true,
                                                              creationDate      : new Date(),
                                                              stockAvailable    : 0,
                                                              stockBooked       : 0,
                                                              stockAssigned     : 0,
                                                              stockThreshold    : 0,
                                                              characteristics   : [],
                                                              prices            : [associatedProduct_price],
                                                            };
  
                                associatedProduct2        = {
                                                              id                : 0,
                                                              name              : title,
                                                              catchword         : '',
                                                              code              : '',
                                                              active            : true,
                                                              creationDate      : new Date(),
                                                              requiredStatus    : 'visitor',
                                                              paymentRequired   : false,
                                                              kind              : 'Video',
                                                              description       : title,
                                                              variants          : [associatedProduct_variant],
                                                              characteristics   : [],
                                                              categoriesIds     : [4],
                                                              associatedMediaId : videoSheetId,
                                                            };
													   
                                const result2 = await createProduct ( associatedProduct2 ) 
                               }
				        }
                   else {
					     // pas de prix, il faut vérifier s'il y en avait un avant
						 
						console.log ( "isEditMode=", isEditMode)
						console.log ( "associatedProduct=", associatedProduct)

						 
						 if (isEditMode && associatedProduct) 
						  {
                           const result3 = await updateProductVisibility ( associatedProduct.id , false )
						  }
				        }						
                 } 
     	   else if (result.code < 1) 
	             {
                  setSaved(true);
                  setProgress(0);
                  setError(true);
                  setErrorMsg(result.comment);
                 }
          } 
	 else {
           setSaveButtonLock(false);
          }
		  */
  };

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //  const fieldIsAlreadyModified = title !== initialVideo.title;
    setTitle(e.target.value);
    // setTitleErrorMessage(testTitle(e.target.value));

    // if (e.target.value === initialVideo.title && fieldIsAlreadyModified) {
      // setNumberOfModifiedFields(prev => Math.max(0, prev - 1));
    // }
    // if (e.target.value !== initialVideo.title && !fieldIsAlreadyModified) {
      // setNumberOfModifiedFields(prev => prev + 1);
    // }
  };

 const handleDescriptionChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    // const fieldIsAlreadyModified = description !== initialVideo.description;
    setDescription(e.target.value);
    // setDescriptionErrorMessage(testDescription(e.target.value));

    // if (e.target.value === initialVideo.description && fieldIsAlreadyModified) {
      // setNumberOfModifiedFields(prev => Math.max(0, prev - 1));
    // }
    // if (e.target.value !== initialVideo.description && !fieldIsAlreadyModified) {
      // setNumberOfModifiedFields(prev => prev + 1);
    // }
  };

  const handleImageFileToUploadChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event && event.target && event.target.files) {
      setImageFileToUpload(event.target.files[0]);
  //    setImageFileToUploadErrorMessage(testImageFileToUpload(event.target.files[0]));
   //   setNumberOfModifiedFields(prev => prev + 1);
    }
  };

  const handleVideoFileToUploadChange = ( event:     React.ChangeEvent<HTMLInputElement> ,
                                          value:     string | number | File | Date       ,
                                          duration?: string                              ) => {
    if (event && event.target && event.target.files) {

      console.log("handleVideoFileToUploadChange",duration)
      if (duration) { setDuration (duration!) }
      setVideoFileToUpload(event.target.files[0]);
    //  setVideoFileToUploadErrorMessage(testVideoFileToUpload(event.target.files[0]));
    //  setNumberOfModifiedFields(prev => prev + 1);
    }
  };

  const handleSaveButton = () => {
    if (!saveButtonLock) {
      setSaveButtonLock(true);
      save();
    } else {
      console.log("LOCK");
    }
  };


  const handleCreationAckButton = () => {
    setSaved(false);
    setProgress(0);
    setSaveButtonLock(false);

    if (isEditMode) {
      if (onEdit) {
        onEdit(adSpotSheetId);
      }
    } else {
      if (onCreate) {
        onCreate(adSpotSheetId);
      }
    }
  };


  const handleErrorAckButton = () => {
    setSaved(false);
    setProgress(0);
    setSaveButtonLock(false);
    window.scroll(0, 0);
  };

  const handleCancelButton2 = () => {
    setCancelation(false);
    setSaved(false);
    setProgress(0);
    setSaveButtonLock(false);
    window.scroll(0, 0);
  };

  const handleValidButton2 = () => {
    setCancelation(false);

    if (isEditMode) {
      if (onEdit) {
        onEdit(0);
      }
    } else {
      if (onCreate) {
        onCreate(0);
      }
    }
  };

  const handleCancelButton3 = () => {
    setCancelation(true);
  };


  const handleActiveChange = ( newState: boolean ) => {
	  
    setActive ( newState )  
  }


  
  return (
    <div className={classNames(styles.root)}>
      {!saved && progress > 0 && (
        <Window
          message={<>Les éléments de la fiche sont en cours d'upload<br />{`${ (progress * 0.9).toFixed(0) }%`} effectués</>}
          messageType="information"
        />
      )}

      {saved && error && (
        <Window
          message={isEditMode ? <>Une erreur est survenue lors de la modification de la fiche</> : <>Une erreur est survenue lors de la création de la fiche</>}
          messageType="information"
          onClickOnValidateButton={handleErrorAckButton}
		  validButtonText="Ok"
        />
      )}

      {saved && !error && (
        <Window
          message={isEditMode ? <>Fiche modifiée</> : <>Fiche créée</>}
          messageType="information"
          onClickOnValidateButton={handleCreationAckButton}
		  validButtonText="Ok"
        />
      )}

      {cancelation && (
        <Window
          message={<>Etes-vous sûr de vouloir annuler vos saisies ?</>}
          messageType="question"
          onClickOnCancelButton={handleCancelButton2}
          onClickOnValidateButton={handleValidButton2}
          validButtonText="Oui"
          cancelButtonText="Non"
        />
      )}

      <div className={classNames(styles.contain)}>

        <div className={classNames(styles.form)}>
          {isEditMode && (
            <div className={classNames(styles.videoId)}>
              <WidgetFrame name="Id :" error="" labelTextPosition="right" labelBlockPosition="left" classNameGrid={classNames(styles.grid_frame)}>
                <p className={classNames(styles.text)}>{id}</p>
              </WidgetFrame>
            </div>
          )}

          {isEditMode && (
            <div className={classNames(styles.creationDate)}>
              <Label value={`Date de création : ${convertDateToString(creationDate, 'dd/MM/yyyy HH:mm')}`} />
            </div>
          )}

          <div className={classNames(styles.active)}>
            <WidgetFrame name="Actif :" labelTextPosition="right" labelBlockPosition="left" classNameGrid={classNames(styles.grid_frame)}>
              <Toggle checked = {active} form="switch" onChange={handleActiveChange}/>
            </WidgetFrame>
          </div>



          <div className={classNames(styles.title)}>
            <WidgetFrame name="Titre :" error={titleErrorMessage} labelTextPosition="right" labelBlockPosition="left" classNameGrid={classNames(styles.grid_frame)}>
              <Field type="text" placeholder="" value={title} onChange={handleTitleChange} />
            </WidgetFrame>
          </div>


          <div className={classNames(styles.description)}>
            <WidgetFrame name="Description :" error={descriptionErrorMessage} labelTextPosition="right" labelBlockPosition="left" classNameGrid={classNames(styles.grid_frame)}>
              <TextArea placeholder="" value={description} onChange={handleDescriptionChange} />
            </WidgetFrame>
          </div>

          <div className={classNames(styles.thumbnail)}>
            <WidgetFrame name="Vignette :" error={imageFileToUploadErrorMessage} labelTextPosition="right" labelBlockPosition="left" classNameGrid={classNames(styles.grid_frame)}>
              {isEditMode ? (
                <Field
                  type="url_or_file_image"
                  placeholder=""
                  value={imageSrc}
                  onChange={handleImageFileToUploadChange}
                  baseURL={WWW_URLS.Thumbnail}
                  extension=".webp"
                />
              ) : (
                <Field type="url_or_file_image" placeholder="" value={imageSrc} onChange={handleImageFileToUploadChange} />
              )}
            </WidgetFrame>
          </div>

          <div className={classNames(styles.video)}>
            <WidgetFrame name="Vidéo :" error={videoFileToUploadErrorMessage} labelTextPosition="right" labelBlockPosition="left" classNameGrid={classNames(styles.grid_frame_2)}>
              {isEditMode ? (
                <Field
                  type="url_or_file_video"
                  placeholder=""
                  value={videoSrc}
                  onChange={handleVideoFileToUploadChange}
                  baseURL={WWW_URLS.Video}
                  extension=""
                />
              ) : (
                <Field type="url_or_file_video" placeholder="" value={videoSrc} onChange={handleVideoFileToUploadChange} />
              )}
            </WidgetFrame>
          </div>

          <div className={classNames(styles.buttons)}>
            <div className={classNames(styles.block_buttons_and_message)}>
              <div className={classNames(styles.block_buttons)}>
                <Trigger name="Annuler" onClick={handleCancelButton3} variant="tailwind2" />
                <Trigger name={isEditMode ? "Enregistrer" : "Créer"} onClick={handleSaveButton} variant="tailwind2" />
              </div>

              {numberOfModifiedFields > 0 && isEditMode && (
                <p className={classNames(styles.alert)}>N’oubliez pas d’enregistrer vos modifications</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdSpotSheet;
